import React from "react";

import svg from "../../assets/images/icons/Form Controls/Data Grid.svg";

export const DataGridIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Data Grid"}
    />
);
